// extracted by mini-css-extract-plugin
export var container = "_5o-0";
export var disabled = "_5o-4";
export var fullWidth = "_5o-3";
export var lined = "_5o-1";
export var selected = "_5o-5";
export var tab = "_5o-2";